import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  textDark: {
    lineHeight: '24px',
    color: colors.neutral900,
  },
  textLight: {
    lineHeight: '19px',
    color: colors.neutral500,
  },
  smLabelLineHeight: {
    lineHeight: '20px',
  },
  smTextLineHeight: {
    lineHeight: '16px',
  },
  levelofEngagementContainer: {
    display: 'flex',
    gap: 8,
  },
  active: {
    background: '#2DA834',
    color: 'white',
    height: 24,
    whiteSpace: 'nowrap',
    // width: 100,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '2px 10px',
    display: 'block',
    textAlign: 'center',
    marginTop: 1,
  },
  activeOutlined: {
    borderColor: colors.success400,
    color: '#268C2B',
    whiteSpace: 'nowrap',
    // width: 100,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '2px 10px',
    display: 'block',
    textAlign: 'center',
  },
  subStatus: {
    marginTop: 1,
    height: 24,
  },
  root2: {
    display: 'grid',
    gridTemplateColumns: '75% 25%',
  },
  btn: {
    height: 40,
    minWidth: '40px !important',
    background: '#F1F8FF',
    width: 40,
    right: 25,
    position: 'absolute',
  },
  isOverFlow: {
    width: 100,
  },
  engaged: {
    background: colors.success500,
  },
  outreachNeeded: {
    background: colors.warning600,
  },
  notEngaged: {
    background: colors.destructive500,
  },
  isPrimary: {
    paddingRight: 10,
  },
});
